import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    DatesName: ""
}

const ADNSlice = createSlice({
    name: "ADNSlice",
    initialState,

    reducers: {
        ADNOptionsData(state, action) {
            return {
                DatesName: action.payload.DatesName,
            };
        }
    }
})
export const { ADNOptionsData } = ADNSlice.actions;
export default ADNSlice.reducer;